module.exports = __webpack_public_path__ + "img/baner_back.10850b21.png";